<div class="flex flex-col bg-black/30 gap-3 py-2 px-3 rounded-lg">
  <div class="flex flex-col gap-3">
    <div>
      @if (usedRows().length) {
        <div class="text-yellow-300 text-xs font-bold">
          Keys used <span class="font-bold">({{ usedRows().length }})</span>:
        </div>
        <ng-container *ngTemplateOutlet="rowList; context: { $implicit: usedRows() }" />
        <div class="w-full h-[0.5px] bg-neutral-700 my-2"></div>
      }

      @if (createdRows().length) {
        <div class="text-blue-300 text-xs font-bold">
          Keys created <span class="font-bold">({{ createdRows().length }})</span>:
        </div>
        <ng-container *ngTemplateOutlet="rowList; context: { $implicit: createdRows() }" />
        <div class="w-full h-[0.5px] bg-neutral-700 my-2"></div>
      }

      @if (optedOutRows().length) {
        <div class="text-neutrals-300 opacity-50 text-xs font-bold">
          Keys opted out <span class="font-bold">({{ optedOutRows().length }})</span>:
        </div>
        <div class="opacity-50">
          <ng-container *ngTemplateOutlet="rowList; context: { $implicit: optedOutRows() }" />
        </div>
      }
    </div>

    <div class="text-neutral-400 text-xs">
      After you apply these changes, you can view them in the Data Model tab.
    </div>

    <button
      [disabled]="!isActiveOutcome()"
      (click)="openModifyModal()"
      class="border border-neutral-400 rounded-full px-3 py-1 text-xs disabled:text-neutral-400 disabled:cursor-not-allowed"
    >
      Modify Keys
    </button>
  </div>
</div>

<ng-template
  #rowList
  let-rows
>
  @for (row of rows; track row.id) {
    <div
      class="flex flex-row items-center gap-2 text-xs/[18px] even:bg-white/5 whitespace-normal py-[2px]"
    >
      <div
        [ngClass]="sourceMarkerClass[row.source]"
        class="h-[14px] w-[2px] shrink-0 rounded-full"
      ></div>
      <div class="flex-grow text-neutral-200 truncate">{{ row.key }}</div>
      <div class="shrink-0 text-neutral-400 lowercase">
        {{ row.type }}{{ row.multiInstance ? '[]' : '' }}
      </div>
    </div>
  }
</ng-template>
